import { createClient } from "@supabase/supabase-js";

const FALLBACK_URL = "https://eswslkevofwdpumphziq.supabase.co";
const FALLBACK_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzd3Nsa2V2b2Z3ZHB1bXBoemlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NDIxMTgsImV4cCI6MjA5NjExODExOH0.I7RvgghMfzmvl_PxEiUvn7hLR81X_E2e-F1bAGkcJLs";

const url = import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_KEY;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
